import deleteBookmarkFunc from './deleteBookmarkFunc';

//お気に入りを localStrage に保存・削除
export default function () {
	const siteurl = document.getElementById('js-page-wrapper').getAttribute('data-siteurl');
	if(jQuery) {
		jQuery(document).on('WordpressUlikeUpdated', function(e, el) {

			console.log(jQuery(el));

			let samerecipesave = localStorage.getItem("samerecipesave");
			if(!samerecipesave) {
				samerecipesave = {
					ids: [],// ボタンとレシピのIDが異なる場合ボタンのidもバックアップ
				};
			} else {
				samerecipesave = JSON.parse(samerecipesave);
			}

			let bookmark = localStorage.getItem("bookmark");
			if(!bookmark) {
				bookmark = {
					ids: []
				};
			} else {
				bookmark = JSON.parse(bookmark);
			}
			const $el = jQuery(el).find('.wp_ulike_btn');
			const $elChild = jQuery(el).find('.wp_ulike_general_class');
			const btnRecipeId = $el.attr('data-ulike-id');
			//お気に入りボタンが書き換えられていれば記事のIDを登録
			let recipeSaveId = $el.attr('data-ulike-id');
			const $wrap = $el.closest('.js-recipe-unit');
			if($wrap.length > 0) {
				const $elDataId = $wrap.find('[data-id]');
				if($elDataId.length > 0) {
					const currentRecipeId = $elDataId.attr('data-id');
					//ボタンとレシピのIDが異なる場合レシピのidを保存
					if(btnRecipeId != currentRecipeId) {
						recipeSaveId = currentRecipeId;
					}
				}
			}
			//同じお気に入りボタンを共有するレシピがあればそちらも保存（ボタンの塗り用）
			if(!samerecipesave.ids.includes(btnRecipeId)) {
				$elChild.addClass('wp_ulike_is_loading');
				axios({
					method: 'get',
					url: siteurl + '/samereciipeapi/',
					responseType:'document',
					params: {
						orgid: btnRecipeId
					},
				})
				.then(function (response) {
					const items = response.data.querySelectorAll('#samerecipe-list li');
					if(items.length > 0) {
						samerecipesave.ids.push(btnRecipeId);
						[].forEach.call(items, function(v,i) {
							samerecipesave.ids.push(v.getAttribute('id'));
						})
						const saveOrgJson = JSON.stringify(samerecipesave);
						localStorage.setItem("samerecipesave", saveOrgJson);
						$elChild.removeClass('wp_ulike_is_loading');
					}
					$elChild.removeClass('wp_ulike_is_loading');
				})
				.catch(function (error) {
					console.log(error);
				});
			}
			//お気に入り保存
			if(!bookmark.ids.includes(recipeSaveId)) {
				bookmark.ids.push(recipeSaveId);
				const saveJson = JSON.stringify(bookmark);
				localStorage.setItem("bookmark", saveJson);

				jQuery('[data-ulike-id="'+btnRecipeId+'"]').each(function() {
					//クリックするとカウントアップされていくのでお気に入り登録済みのものは押せないようにする
					jQuery(this).prop('disabled', true);
					const div = document.createElement('div');
					div.classList.add('shield');
					jQuery(this).closest('.wpulike').append(div);
				});

			} else {
				console.log("登録済みです");
			}
		});

		jQuery('#js-page-wrapper').on('click', '.shield', function(e) {
			const $parent = jQuery(this).closest('.wpulike');
			const $elChild = $parent.find('.wp_ulike_general_class');
			const $btn = $parent.find('.wp_ulike_btn');
			if($btn.prop('disabled')) {
				const btnRecipeId = $btn.attr('data-ulike-id');
				//お気に入りボタンが書き換えられていれば記事のIDを削除
				let recipeDeleteId = $btn.attr('data-ulike-id');
				const $wrap = $btn.closest('.js-recipe-unit');
				if($wrap.length > 0) {
					const $elDataId = $wrap.find('[data-id]');
					if($elDataId.length > 0) {
						const currentRecipeId = $elDataId.attr('data-id');
						if(btnRecipeId != currentRecipeId) {
							recipeDeleteId = currentRecipeId;
						}
					}
				}

				//お気に入りボタンを共有するレシピがないか検索
				$elChild.addClass('wp_ulike_is_loading');
				axios({
					method: 'get',
					url: siteurl + '/samereciipeapi/',
					responseType:'document',
					params: {
						orgid: btnRecipeId
					},
				})
				.then(function (response) {
					const items = response.data.querySelectorAll('#samerecipe-list li');
					//同じお気に入りボタンを共有するレシピがあればそちらも削除（ボタンの塗り用）
					deleteBookmarkFunc(items, btnRecipeId, recipeDeleteId);
					//like button が複数ある場合
					jQuery('[data-ulike-id="'+btnRecipeId+'"]').each(function() {
						jQuery(this).prop('disabled', false);
						jQuery(this).closest('.wpulike').find('.shield').remove();
					});

					$elChild.removeClass('wp_ulike_is_loading');
				})
				.catch(function (error) {
					console.log(error);
				});

			}
		});
	}
}
